/**
 * Creates the store for the appearance (light / dark theme).
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */
export default function (Alpine) {
  Alpine.store("appearance", {
    theme: Alpine.$persist("system").as("theme"),

    get resolved() {
      if (this.theme === "system") {
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      }
      return this.theme;
    },

    toggle() {
      this.theme = this.resolved === "dark" ? "light" : "dark";
    },

    init() {
      Alpine.effect(() => {
        const root = document.documentElement;
        root.setAttribute("data-no-transition", "");
        root.setAttribute("data-theme", this.theme);
        setTimeout(() => root.removeAttribute("data-no-transition"));
      });
    },
  });
}
